import { Box, Typography } from '@mui/material';
import React from 'react';

import { CloseIcon } from '@/shared/assets/icons/close-icon';
import { InfoIcon } from '@/shared/assets/icons/info-icon';
import { AlertContainer } from '@/shared/components/ui/alert/alert.styled';
import { TAlertProps } from '@/shared/components/ui/alert/alert.types';
import { IconButton } from '@/shared/components/ui/button/icon-button/icon-button';

export const Alert: React.FC<TAlertProps> = ({ color, text, onClose }) => {
  return (
    <AlertContainer
      direction="row"
      $color={color}
      alignItems="center"
      gap="0.5rem"
      width="100%"
    >
      <Box className="main-icon" alignSelf="flex-start">
        <InfoIcon />
      </Box>

      <Typography variant="p5">{text}</Typography>

      {onClose && (
        <Box className="close-button">
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      )}
    </AlertContainer>
  );
};
